import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthCallbackComponent } from 'auth-callback-lib';
import { DocumentClientComponent } from './doc-client/document-client.component';

const routes: Routes = [
  { path: 'callback', component: AuthCallbackComponent },
  { path: '**', component: DocumentClientComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
